export const URI_EXTRACT_ADHOC_REQUEST = "URI_EXTRACT_ADHOC_REQUEST"
export const URI_EXTRACT_ADHOC_RECEIVE = "URI_EXTRACT_ADHOC_RECEIVE"
export const URI_EXTRACT_ADHOC_FAILURE = "URI_EXTRACT_ADHOC_FAILURE"
